import { DeleteOutlineOutlined, EditOutlined } from "@mui/icons-material";
import { Box, IconButton, TablePagination } from "@mui/material";
import React from "react";

const TableAction = ({ onEdit, onDelete }) => {
  return (
    <Box>
      {onEdit && (
        <IconButton
          sx={{ color: (theme) => theme.palette.primary.main }}
          onClick={onEdit}
          size="small"
        >
          <EditOutlined />
        </IconButton>
      )}
      {onDelete && (
        <IconButton
          sx={{ color: (theme) => theme.palette.error.main }}
          onClick={onDelete}
          size="small"
        >
          <DeleteOutlineOutlined />
        </IconButton>
      )}
    </Box>
  );
};

export default TableAction;

export const CustomTablePagination = ({
  count,
  rowsPerPage,
  page,
  onPageChange,
  handleChangeRowsPerPage,
}) => {
  return (
    <TablePagination
      labelRowsPerPage="Rows Per Page"
      rowsPerPageOptions={[5, 10, 15]}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={(e, val) => onPageChange(val)}
      onRowsPerPageChange={handleChangeRowsPerPage}
      slotProps={{
        select: {
          style: {
            border: "1px solid gray",
            borderRadius: "4px",
          },
        },
      }}
    />
  );
};

export const EmailRow = ({ email }) => {
  return (
    <Box
      sx={{ color: (theme) => theme.palette.info.main, cursor: "pointer" }}
      onClick={() => (window.location.href = `mailto:${email}`)}
    >
      {email}
    </Box>
  );
};
